import React from 'react';
import Icon from '../atoms/Icon';

function PositionRankIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox="0 0 30 32">
      <g 
        fill='currentColor' 
        fillRule='nonzero'
      >
        <path d="M18.3457 0V12.4119H24.8324L14.894 24.8665L4.95554 12.4119H11.4413V0H18.3457ZM13.3807 14.3513H8.98394L14.893 21.7557L20.8031 14.3513H16.4063V1.93939H13.3807V14.3513Z"/>
        <path d="M22.0601 20.3016L20.2975 22.5097C24.6368 23.2321 27.3067 24.7104 27.3067 25.7939C27.3067 27.2759 22.3567 29.5176 14.8945 29.5176C7.43238 29.5176 2.48242 27.2759 2.48242 25.7939C2.48242 24.7104 5.15227 23.2321 9.49155 22.5109L7.72903 20.3028C3.32521 21.235 0 23.0819 0 25.7939C0 29.8688 7.4932 32 14.8945 32C22.2959 32 29.7891 29.8688 29.7891 25.7939C29.7891 23.0819 26.4639 21.235 22.0601 20.3016Z"/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(PositionRankIcon);
